import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-success" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = ["href"]

import { Affiliate } from "@/services/types/affiliate";
    import { ElDivider, ElMessage, FormInstance, FormRules } from "element-plus"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AffiliateView',
  props: {
    affiliate: {}
  },
  setup(__props: any) {

    const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    animated: "",
    loading: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[0] || (_cache[0] = _createTextVNode(" Nome: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.affiliate.user.name), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" Telefone: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.affiliate.user.phone), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" Saldo Total: ", -1)),
          _createElementVNode("strong", _hoisted_2, _toDisplayString(__props.affiliate.balance.toFixed(2)) + "MT", 1)
        ]),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createTextVNode(" Afiliado desde: ", -1)),
          _createElementVNode("strong", _hoisted_3, _toDisplayString(new Date(__props.affiliate.created_at ?? 0).toLocaleString()), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Código: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.affiliate.id), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createTextVNode(" Link de afiliado: ", -1)),
          _createElementVNode("a", {
            target: "_blank",
            href: `https://beasymoz.com?affiliate_id=${__props.affiliate.id}`,
            class: "text-success"
          }, _toDisplayString(`https://beasymoz.com?affiliate_id=${__props.affiliate.id}`), 9, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})